import { combineReducers } from 'redux-immutable';

/**
Import your reducer functions here
and then combine them
**/
import errors from './errors';
import location from './location';
import users from './users';
import filterOptions from './filterOptions';
import activeFilters from './activeFilters';
import policies from './policies';
import collectives from './collectives';
import influencers from './influencers';
import viewState from './viewState';
import currentUser from './currentUser';
import importer from './importer';

const rootReducer = combineReducers({
  influencers,
  collectives,
  policies,
  errors,
  location,
  users,
  filterOptions,
  activeFilters,
  viewState,
  currentUser,
  importer,
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./reducers/index.js
 **/